import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import MaterialMovementsOperations from "../utils/material-movements-operations.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { storageOptions, materialStorageOptions, groupOptions } = useReportFiltersFetch({fetchStorage: true, fetchMaterialStorage: true, fetchGroup: true});

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Operação'
                        isMulti={true}
                        options={MaterialMovementsOperations.options}
                        value={filters.operation}
                        onChange={(value) => setFilters(prev => ({...prev, operation: value}))}
                        instanceId="operation"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <SelectComponent
                        label='Depósito'
                        isMulti={true}
                        wrapValues={true}
                        options={storageOptions}
                        value={filters.storage}
                        onChange={(value) => setFilters(prev => ({...prev, storage: value}))}
                        instanceId="storage"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Grupo'
                        isMulti={true}
                        wrapValues={true}
                        options={groupOptions}
                        value={filters.group}
                        onChange={(value) => setFilters(prev => ({...prev, group: value}))}
                        instanceId="group"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Material'
                        isMulti={true}
                        wrapValues={true}
                        options={materialStorageOptions}
                        value={filters.material_storage}
                        onChange={(value) => setFilters(prev => ({...prev, material_storage: value}))}
                        instanceId="material_storage"
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        label="Número de série/patrimônio"
                        value={filters.serial_or_assetNumber}
                        onChange={({target}) => setFilters(prev => ({ ...prev, serial_or_assetNumber: target.value }))}
                        instanceId="serial_or_assetNumber"
                        id="serial_or_assetNumber"
                        classNameWrapper={"w-full"}
                    />

                    <AccessForm filters={filters} setFilters={setFilters} customTitle={'Solicitante'}/>

                    <div className={"mb-2 ml-1"}>
                        <InputCheckbox
                            id="is_gun"
                            label="Arma de fogo"
                            checked={filters.is_gun}
                            onChange={(e) => setFilters(prev => ({...prev, is_gun: e.target.checked}))}
                        />
                    </div>

                    <div className={"mb-2 ml-1"}>
                        <InputCheckbox
                            id="is_unique"
                            label="Controlado por número de série"
                            checked={filters.is_unique}
                            onChange={(e) => setFilters(prev => ({...prev, is_unique: e.target.checked}))}
                        />
                    </div>

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="is_caution"
                            label="Usado em cautela"
                            checked={filters.is_caution}
                            onChange={(e) => setFilters(prev => ({...prev, is_caution: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;